/**
 * LOT-UI-03b.1 — Drawer « Plus » (DS Remobiles, touch-friendly).
 */
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { getPlusMenuSections } from './plusMenuConfig';

const StaffPlusDrawer = ({ open, onClose }) => {
  const { user, isAdmin } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();
  const sections = getPlusMenuSections({ isAdmin, isSuperAdmin: user?.magasin_role === 'super_admin', user, t });

  if (!open) return null;

  const isActive = (path) => {
    const base = path.split('?')[0];
    return location.pathname === base || location.pathname.startsWith(`${base}/`);
  };

  return (
    <>
      <div
        className="fixed inset-0 bg-black/55 z-[90] top-16"
        onClick={onClose}
        data-testid="plus-drawer-overlay"
      />
      <aside
        className="fixed top-16 right-0 w-full sm:max-w-sm h-[calc(100vh-4rem)] z-[95] overflow-y-auto shadow-2xl"
        style={{
          background: 'var(--rm-bg-panel)',
          borderLeft: '1px solid var(--rm-border-subtle)',
        }}
        data-testid="plus-drawer"
      >
        <div
          className="sticky top-0 flex items-center justify-between px-4 py-3 border-b"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
        >
          <h2 className="font-bold text-[var(--rm-white)]">Plus</h2>
          <button
            type="button"
            onClick={onClose}
            className="rm-touch rounded-xl text-[var(--rm-gray-400)] hover:text-[var(--rm-white)] hover:bg-white/5"
            aria-label="Fermer"
            data-testid="plus-drawer-close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-3 sm:p-4 space-y-5 pb-28">
          {sections.map((section) => (
            <div key={section.key}>
              <div className="text-[10px] font-semibold uppercase tracking-wider text-[var(--rm-gray-500)] mb-2 px-1">
                {section.label}
              </div>
              <div className="space-y-0.5">
                {section.items.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={onClose}
                    className={`flex items-center gap-3 px-3 py-3 min-h-[44px] rounded-xl text-sm transition-all ${
                      isActive(item.path)
                        ? 'bg-[var(--rm-red-muted)] text-[var(--rm-white)] font-medium'
                        : 'text-[var(--rm-gray-400)] hover:bg-white/5 hover:text-[var(--rm-white)]'
                    }`}
                    data-testid={`plus-${item.path.replace(/\//g, '-')}`}
                  >
                    <item.icon className="w-4 h-4 flex-shrink-0" />
                    <span>{item.label}</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </aside>
    </>
  );
};

export default StaffPlusDrawer;
